import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-new-movement',
		path: '/admin/start_a_movement',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_new_movement" */ './index'), {
			exportName: 'AdminNewMovement',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		frame: true,
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
